import setSceneLayers from './setSceneLayers';

/**
 * Updates scenelayers
 *
 * This is meant to be called after another logged in director changes a background/overlay, emitting
 * a SCENE_LAYERS_UPDATED event, which necessitates that all other directors to have updated scene layers
 */
export default sceneLayers => {
  return dispatch => {
    dispatch(setSceneLayers(sceneLayers));
  };
};
